/* eslint-disable react/prop-types */
import Sticky from 'react-sticky-el'
import { useTranslation } from 'react-i18next'

import Footer from '../components/Footer'
import PoliticaPrivacidad from './PoliticaPrivacidad'
import PoliticaCookies from './PoliticaCookies'

import '../assets/styles/css/Legal.css'
import LegalNotice from './LegalNotice/LegalNotice'
import WhatsappGroups from './WhatsappGroups'

function Legal(props) {
  const { t } = useTranslation()

  return (
    <div className={'legalCnt'}>
      <h1>
        {t('Aviso legal, política de privacidad y política de')}{' '}
        <i>{t('cookies')}</i>
      </h1>
      <div className={props.isStiky ? 'active' : 'inactive'}>
        <Sticky
          className={'anchors'}
          onFixedToggle={(isStiky) => props.fixSticky(isStiky)}
          scrollElement='.container'
        >
          <ul>
            {props.select.map((selects, index) => (
              <a
                className={!selects.isSelected ? '' : 'selected'}
                href={`#${selects.type}`}
                key={selects.type}
                onClick={() => props.type(selects.type, index)}
                role='presentation'
              >
                {selects.type === 'whatsappGroups' && (
                  <li>{t('Grupos de Whatsapp')}</li>
                )}
                {selects.type === 'politicaCookies' && (
                  <li>
                    {t('Política de')} <i>{t('Cookies')}</i>
                  </li>
                )}
                {selects.type === 'politicaPrivacidad' && (
                  <li>{t('Política de Privacidad')}</li>
                )}
                {selects.type === 'avisoLegal' && <li>{t('Aviso legal')}</li>}
              </a>
            ))}
          </ul>
        </Sticky>
        <div className={'legalText'}>
          <LegalNotice />
          <PoliticaPrivacidad />
          <PoliticaCookies />
          <WhatsappGroups />
        </div>
      </div>
      <Footer />
    </div>
  )
}
export default Legal
